module.exports = __webpack_public_path__ + "img/icone-quadrado-azul.87090afa.png";